import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cacheTags } from '../../../hooks/useMemorizedCacheTag';
import { DivisionForm } from '../forms/DivisionForm';

type DivisionModalProps = {
  cacheTag: keyof typeof cacheTags;
  divisionUuid: string | null;
  isOpen: boolean;
  superiorClass: { name: string; uuid: string };
  onClose: () => void;
};

export const DivisionModal = ({ cacheTag, divisionUuid, isOpen, superiorClass, onClose }: DivisionModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={divisionUuid ? t('divisions.edit') : t('divisions.add')}
      isOpen={isOpen}
      loading={loading}
      shouldCloseOnEsc={false}
      onRequestClose={() => onClose()}
    >
      <DivisionForm
        cacheTag={cacheTag}
        divisionUuid={divisionUuid}
        superiorClass={superiorClass}
        onClose={() => onClose()}
        onLoad={(loading) => setLoading(loading)}
      />
    </Modal>
  );
};
